import { Injectable, signal } from '@angular/core';

@Injectable()
export class MdmSignalsService {
  private isNavbarVisible = signal<boolean>(true); // Default state is visible
  public plantLineFilter = signal<any>({
    plant_code: [],
    line_code: [],
    product_format: [],
    pack_format: [],
    geography: [],
    start_quarter: [],
    end_quarter: [],
  });
  public reloadInterventionsTable = signal<boolean>(false);
  public reloadBDSummaryTable = signal<boolean>(false);

  constructor() {}

  get navbarVisible() {
    return this.isNavbarVisible.asReadonly();
  }

  toggleNavbarVisibility() {
    this.isNavbarVisible.set(!this.isNavbarVisible()); // Toggle the current state
  }

  clearPlanLineSignal() {
    this.plantLineFilter.set({
      plant_code: [],
      line_code: [],
      product_format: [],
      pack_format: [],
      geography: [],
      start_quarter: [],
      end_quarter: [],
    });
  }
}
